<!-- Header removed for parents view -->
<!-- <app-header *ngIf="!auth.isCb3"></app-header>  -->
<div class="container">
  <div *ngIf="auth.isCb3" style="height:25px"></div>
  <router-outlet></router-outlet>
</div>
